/* eslint-disable arrow-body-style */

import http from '@gp/utils/httpTS';

import type { IBaseResponse } from '@home/types/common';

export const fetchShortUrlParams = (params: { key: string }): IBaseResponse<{ params: string }> => {
  return http({
    url: '/api/v1/globalpedia_pc/common/get_short_url',
    method: 'POST',
    data: params,
    rawData: true,
  }) as any;
};

export const updateShortUrlParams = (params: {
  params: string;
}): IBaseResponse<{ key: string }> => {
  return http({
    url: '/api/v1/globalpedia_pc/common/write_short_url',
    method: 'POST',
    data: params,
    rawData: true,
  }) as any;
};

/**
 * 获通用筛选器配置数据
 */
export const fetchCommonConditions = async (params: any = {}): Promise<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/cond',
    method: 'POST',
    data: params,
    rawData: false,
  }) as any;
};

/**
 * 添加筛选器保存方案
 */
export const addFilterSave = async (params: any = {}): Promise<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/filter_save/create',
    method: 'POST',
    data: params,
    rawData: false,
  }) as any;
};

/**
 * 获取筛选器保存方案
 */
export const getFilterSave = async (params: any = {}): Promise<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/filter_save/get',
    method: 'POST',
    data: params,
    rawData: false,
  }) as any;
};

/**
 * 获取筛选器保存方案
 */
export const getFilterSaveList = async (params: any = {}): Promise<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/filter_save/list',
    method: 'POST',
    data: params,
    rawData: false,
  }) as any;
};

/**
 * 编辑筛选器保存方案
 */
export const editFilterSave = async (params: any = {}): Promise<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/filter_save/edit',
    method: 'POST',
    data: params,
    rawData: false,
  }) as any;
};

/**
 * 删除筛选器保存方案
 */
export const deleteFilterSave = async (params: any = {}): Promise<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/filter_save/delete',
    method: 'POST',
    data: params,
    rawData: false,
  }) as any;
};
